import {
    CHANGE_AUTH,
    REST_API,
    EYM_TKN,
    EYM_TKN_OBJ,
    EYM_USR,
    GET_METHOD,
    POST_METHOD,
    PATCH_METHOD,
    DELETE_METHOD
} from './constants'


export function updatePreference(id,endpoint,token,body)
{
// console.log("endpoint",endpoint)
// console.log("token",token)
// console.log("body",body)
    return dispatch => {
        return fetch(`${REST_API}/${endpoint}/${id}?access_token=${token}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }).then(response => {
            return response
        })
        // .then(json =>{
        //     console.log("JSON",json)
        //     return json
        // })

        
    }
}



// WEBPACK FOOTER //
// ./src/actions/preference.js